export class ListBackupVaultResponse {
    'vaults';
    'nextToken';
    'totalCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaults",
            "baseName": "vaults",
            "type": "Array<BackupVault>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupVaultResponse.attributeTypeMap;
    }
    constructor() {
    }
}
